import { ReactNode, useMemo } from "react"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js/pure"

export const StripeSepaWrapper = ({ children }: { children: ReactNode }) => {
  const stripePromise = useMemo(() => loadStripe(window.gon.stripeOysterHrLtdPublishableKey), [])

  return <Elements stripe={stripePromise}>{children}</Elements>
}
